import { Injectable } from '@angular/core';
import { RequestService } from "clicklease-ui-elements";
import { environment } from '@envs/environment';
import { DisclosureLogin } from '../../interfaces/disclosure-login';
import { map, Observable } from 'rxjs';
import { response } from 'express';

export interface DisclosureTextResponse {
    Id: string;
    Name: string;
    DisclosureText: string;
}



@Injectable({
    providedIn: 'root'
})
export class DisclosureLoginService extends RequestService {
    protected readonly serviceBaseUrl: string = `${environment.API_URL}`;


    public postDisclosureLogin(disclosureName: String): Observable<DisclosureLogin> {
        return this.post<DisclosureLogin>({
            url: `disclosures/filter`,
            headers: { 'content-type': 'application/json' },
            params: {
                disclosureName,
                returnType: 'HTML'
            }
        }).pipe(map((response: DisclosureLogin) => response));
    }

    public postDisclosureLoginSucces(requestBody: {disclosureName: string, roseKey: string, attributes:{name: string, value: string}[] }): Observable<void> {
        return this.post<void>({
            url: `disclosures`,
            headers: { 'content-type': 'application/json' },
            params: requestBody
        });
    }

    //For get the Bank update info disclosure
    public getBankDisclosure(disclosureName: string, returnType: string, attributes: {name:string, value:string}[]):Observable<DisclosureLogin>{
        return this.post<DisclosureLogin>({
            url: `disclosures/filter`,
            headers: { 'content-type': 'application/json' },
            params: {
                disclosureName,
                returnType,
                attributes
            }
        }).pipe(map((response: DisclosureLogin) => response));
    }

    // To set the disclosure new Bank info to SF
    public postBankDisclosure(roseKey: string, disclosureName:string, attributes: {name:string, value:string}[]):Observable<void>{
        return this.post<void>({
            url:`disclosures`,
            headers:{'content-type': 'application/json'},
            params:{
                roseKey,
                disclosureName,
                attributes
            }
        })
    }

    public getDisclosureText(name: string): Observable<DisclosureTextResponse> {
        return this.get<DisclosureTextResponse>({
            url: `disclosures/texts/${encodeURIComponent(name)}`,
            headers: { 'content-type': 'application/json' }
        });
    }

}
